import { useAppSettings } from "contexts/AppSettingsContext";
import { eApplicationPermission } from "functions/api/enums";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

/**
 * Top bar help dropdown showing available help links and admin shortcut.
 */
export const HelpLinkDropDown = () => {
  const appSettings = useAppSettings();

  return (
    <NavDropdown
      id="topbar-help"
      title="Help"
    >
      {(appSettings.isAdmin ||
        appSettings.applicationPermissions.filter((p) =>
          [eApplicationPermission.AllowHelpEdit, eApplicationPermission.AllowNewsEdit].includes(p),
        ).length > 0) && (
        <NavDropdown.Item
          id="topbar-admin-link"
          as={Link}
          to={"/Admin#news"}
        >
          Admin page
        </NavDropdown.Item>
      )}
      {appSettings.helpLinks.map((h, i) => (
        <NavDropdown.Item
          key={i}
          id={`topbar-help-link-${i}`}
          target={"_blank"}
          href={h.linkUrl}
        >
          {h.linkLabel}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

HelpLinkDropDown.displayName = "HelpLinkDropDown";
